import {Component, Input} from '@angular/core';
import {NumberPipe} from '../../settings/number.pipe';
import {TranslateModule} from '@ngx-translate/core';
import {stockPercent} from './stock-summary.model';

@Component({
  selector: 'sm-stock-summary',
  standalone: true,
  imports: [NumberPipe, TranslateModule],
  templateUrl: './sm-stock-summary.component.html',
  styleUrls: ['./sm-stock-summary.component.scss'],
})
export class SmStockSummaryComponent {
  @Input() quantity: number | null | undefined = null;
  @Input() packagingQuantity: number | null | undefined = null;
  @Input() remaining: number | null | undefined = null;
  @Input() unitLabel: string | null | undefined = null;
  @Input() stockUnitLabel: string | null | undefined = null;
  @Input() desired: number | null | undefined = null;
  @Input() semantics: 'inventory' | 'basket' = 'inventory';
  @Input() aggregateCapacity: number | null | undefined = undefined;

  get splitRemaining(): {full: number; extra: number} | null {
    if (this.semantics !== 'inventory' || !this.stockUnitLabel || this.remaining == null
      || !Number.isFinite(this.remaining) || this.remaining < 0 || !this.packagingQuantity
      || !Number.isFinite(this.packagingQuantity) || this.packagingQuantity <= 0) return null;
    const capacity = Math.round(this.packagingQuantity * 1000);
    const remaining = Math.round(this.remaining * 1000);
    if (capacity === 0) return null;
    return {full: Math.floor(remaining / capacity), extra: (remaining % capacity) / 1000};
  }

  get capacity(): number | null {
    if (this.semantics === 'basket') return this.desired ?? null;
    if (this.aggregateCapacity !== undefined) return this.aggregateCapacity;
    return this.quantity != null && this.packagingQuantity != null ? this.quantity * this.packagingQuantity : null;
  }
  get available(): number | null { return this.semantics === 'basket' ? this.quantity ?? null : this.remaining ?? null; }
  get percent(): number | null { return stockPercent(this.available, this.capacity); }
  get packaged(): boolean { return this.packagingQuantity != null || this.aggregateCapacity !== undefined; }
}
